import { ErrorText } from '../../components/ErrorText';
import { PageHeading } from '../../components/PageHeading';
import { PanelCard } from '../../components/PanelCard';
import { SectionHeader } from '../../components/SectionHeader';
import { SkeletonCard } from '../../components/SkeletonCard';
import { GuestDetailsPanel } from '../GuestDetailsPanel';
import { ErrorRow, Intro, MetaText, ScrollContainer } from './GolfPlayersContent.styles';
import type { GolfPlayersContentProps } from './GolfPlayersContent.types';

const NO_OP = () => {};

export function GolfPlayersContent({
  metaText,
  isLoading,
  players,
  onPlayerChange,
  errorMessage,
  labels,
}: GolfPlayersContentProps) {
  return (
    <ScrollContainer>
      <Intro>
        <PageHeading title={labels?.title ?? 'Golf.'} subtitle={labels?.subtitle} />
        {metaText && <MetaText>{metaText}</MetaText>}
      </Intro>

      {isLoading
        ? players.map((player) => <SkeletonCard key={player.playerNumber} variant="simple" />)
        : players.map((player, playerIndex) => (
            <PanelCard key={player.playerNumber}>
              <SectionHeader
                title={
                  labels?.playerTitleFormatter
                    ? labels.playerTitleFormatter(player.playerNumber)
                    : `Player ${player.playerNumber}.`
                }
              />
              {/* GuestDetailsPanel's own header carries a default subtitle golf does not want. */}
              <GuestDetailsPanel
                guestNumber={player.playerNumber}
                showHeader={false}
                showTitle={false}
                showGender={false}
                onExistingGuestSelect={NO_OP}
                values={player.values}
                errors={player.errors}
                requiredFields={{
                  firstName: player.required,
                  lastName: player.required,
                }}
                onChange={(field, value) => onPlayerChange(playerIndex, field, value)}
                labels={labels?.playerDetails}
              />
            </PanelCard>
          ))}

      {errorMessage && (
        <ErrorRow role="alert">
          <ErrorText>{errorMessage}</ErrorText>
        </ErrorRow>
      )}
    </ScrollContainer>
  );
}
